import { render } from "./ecormmerceIncome2.vue?vue&type=template&id=0c169628"
import script from "./ecormmerceIncome2.vue?vue&type=script&lang=js"
export * from "./ecormmerceIncome2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__